import React from 'react';
import { LiveIndicator } from './components/LiveIndicator';
import { VideoPlayer } from './components/VideoPlayer';
import { CountdownTimer } from './components/CountdownTimer';
import { ActionButton } from './components/ActionButton';
import { GiftIcon } from 'lucide-react';
import { BonusCard } from './components/BonusCard';
import { PricingCard } from './components/PricingCard';
import { ValueSummary } from './components/ValueSummary';
import { CompleteSystemOffer } from './components/CompleteSystemOffer';
import { WhatsAppButton } from './components/WhatsAppButton';
import { FAQ } from './components/FAQ';
import { CaseStudyVideo } from './components/CaseStudyVideo';
export function App() {
  return <div className="min-h-screen" data-id="element-0">
      {/* Dark section - Header, Video, CTA */}
      <div className="bg-gradient-to-b from-gray-900 to-black text-white" data-id="element-1">
        <div className="container mx-auto px-4 py-12 max-w-5xl" data-id="element-2">
          <div className="flex justify-center mb-6" data-id="element-3">
            <LiveIndicator data-id="element-4" />
          </div>

          <div className="text-center mb-8" data-id="element-5">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4" data-id="element-6">
              Cómo Generar de $500-$1000/día con el poder de la Inteligencia
              Artificial
            </h1>
            <p className="text-xl text-gray-300 mt-4" data-id="element-7">
              Masterclass exclusiva: Aprende estrategias probadas para generar
              ingresos con IA
            </p>
          </div>

          <div className="overflow-hidden mb-8" style={{
          boxShadow: '0 0 40px rgba(220, 38, 38, 0.6), 0 0 80px rgba(220, 38, 38, 0.4), 0 20px 100px rgba(220, 38, 38, 0.3)'
        }} data-id="element-8">
            <VideoPlayer data-id="element-9" />
          </div>

          <div className="mt-8 text-center pb-12" data-id="element-10">
            <CountdownTimer data-id="element-11" />
            <div className="mt-8" data-id="element-12">
              <ActionButton data-id="element-13" />
            </div>
          </div>
        </div>
      </div>

      {/* White section - Bonus images and gift button */}
      <div className="bg-white" data-id="element-14">
        <div className="container mx-auto px-4 py-12 max-w-5xl" data-id="element-15">
          <div className="mt-8" data-id="element-16">
            <PricingCard data-id="element-17" />

            {/* Case Study Video */}
            <CaseStudyVideo data-id="element-18" />

            <BonusCard bonusNumber={1} title="BOVEDA DE AI PROMPTS" description="Más de 1,000 prompts probados y optimizados para IA. Copia y pega para obtener resultados instantáneos en tus campañas y contenidos." imageSrc="https://cdn.magicpatterns.com/uploads/xi8Aqi4p2fcNffNAdv6eaW/Screenshot_2026-01-08_at_11.01.25_PM.png" data-id="element-19" />

            <BonusCard bonusNumber={2} title="AI PRODUCT ROLODEX" description="La Lista de 60 productos digitales y nichos validados listos para lanzar. Nicho, avatar, targeting, ads, todo." imageSrc="https://cdn.magicpatterns.com/uploads/dQQyhq5ofiFSdVHXGevL5m/Screenshot_2026-01-08_at_11.00.51_PM.png" data-id="element-20" />

            <BonusCard bonusNumber={3} title="PLANTILLAS DFY COPYWRITING" description="Plantillas DFY Copy hechas para ti." features={['VSL Scripts', 'Sales Copywriting', 'Email and SMS copy', 'Abandonment Cart']} imageSrc="https://cdn.magicpatterns.com/uploads/rjrfMP1TNvhRaA5Ge8vaTi/c760a89c-ca2b-42bf-9bb2-fffe9652a3d5.png" data-id="element-21" />

            <BonusCard bonusNumber={4} title="AI INCOME CALCULATOR" description="Calculadora para calcular los ingresos de tu funnel y productos digitales." features={['Click Roas', 'AOV', 'LTV']} imageSrc="https://cdn.magicpatterns.com/uploads/sbsgqc4DbHfc6rMsr661hd/0b3c81b5-279c-4857-99ab-94f80e2fc784.png" data-id="element-22" />

            <BonusCard bonusNumber={5} title="VIRAL VIDEO MACHINE" description="Crea Videos Virales con AI. Sin grabar, sin editar, sin diseñar. Nada. Todo hecho por IA." features={['Videos que han tenido millones de views y ventas']} imageSrc="https://cdn.magicpatterns.com/uploads/v1Fv9jrn3PZg3qgffKZ7PN/f2daf09f-8d0d-419a-a6db-476b7c45c64e.png" data-id="element-23" />

            <ValueSummary data-id="element-24" />

            <CompleteSystemOffer data-id="element-25" />
          </div>

          {/* FAQ Section */}
          <FAQ data-id="element-26" />

          <div className="text-center mt-8" data-id="element-27">
            <ActionButton data-id="element-28" />
          </div>

          <div className="text-center mt-8" data-id="element-29">
            <a href="https://regalo.marketingconia.live/" target="_blank" rel="noopener noreferrer" className="w-full inline-flex items-center justify-center gap-2 bg-gradient-to-r from-green-600 to-green-800 hover:from-green-700 hover:to-green-900 text-white font-bold py-4 px-8 rounded-lg text-xl transition-all transform hover:scale-105 shadow-lg hover:shadow-xl" data-id="element-30">
              <GiftIcon className="w-6 h-6" data-id="element-31" />
              ¡Reclama Tu Regalo Gratis!
            </a>
          </div>
        </div>
      </div>

      {/* Floating WhatsApp Button */}
      <WhatsAppButton data-id="element-32" />
    </div>;
}